import React, { useRef } from 'react'
import vendor_terms_conditions from '../../API/Resources/terms_conditions/vendor_terms_conditions'
import ReactMarkdown from 'react-markdown';
import './vendor_terms_conditions.css';
export default function VendorTermsConditions() {
  const sectionRefs = useRef({});
  
    const scrollToSection = (id) => {
      const element = sectionRefs.current[id];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
  return (
    <div className='container'>
      <div className="tac-container">
        <nav className="sidebar">
          <h2 className="sidebarTitle">Table of Contents</h2>
          <ul className="navList">
            {vendor_terms_conditions.map((section) => (
              <li key={section.id} className="navItem">
                <button onClick={() => scrollToSection(section.id)} className="navButton">
                  {section.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <main className="content">
          <h1 className='tac-title'>Vendor Terms and Conditions</h1>
          {vendor_terms_conditions.map((section) => (
            <div
              key={section.id}
              id={section.id}
              ref={(el) => (sectionRefs.current[section.id] = el)}
              className="section h-auto my-5"
            >
              <h2 className="sectionTitle">{section.title}</h2>
              <section className="sectionContent" >
                <ReactMarkdown>{section.content}</ReactMarkdown>
              </section>
            </div>
          ))}
        </main>
      </div>
    </div>
  )
}
